import { Link } from "react-router-dom";
import "./Terms.css";

const Terms = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1 className="terms-title">Terms and Conditions</h1>
        <p className="terms-update">Last updated: Thursday, 17 April 2025</p>

        <div className="terms-content">
          <p>
            Please read these rules carefully before using the{" "}
            <a href="https://healthwiibes.com/" className="terms-link">
              https://healthwiibes.com/
            </a>{" "}
            website (the "Site"). Your ability to use the site depends on whether you agree to and follow these rules. These rules apply to everyone who visits or uses the site.
          </p>
          <p>
            By using the site, you agree to follow these rules. If you disagree with any part of them, you cannot use the site.
          </p>

          <h2 className="terms-subtitle">Ownership of Content</h2>
          <p>
            The site and its original stuff, including images, videos, content, features, tools, and functions, are owned by [healthwiibes.com] and are protected by international laws about copyright, trademark, patent, secret business information, and other rights about intellectual property or property.
          </p>

          <h2 className="terms-subtitle">As an author or contributor</h2>
          <p>
            In the future If you are willing to work on the website as an author or contributor, then you will be responsible for keeping it safe and for what happens when someone uses your author account. You agree to give true and complete information when making a request to become an author or contributor and to keep it updated.
          </p>

          <h2 className="terms-subtitle">Content</h2>
          <p>
            In the future as an author, our site will let you share information, text, pictures, videos, or other things ("content"). You are responsible for what you share on the site, including if it's legal, reliable, and right to share. When you share content on the site, you allow us to use, change, show, and share that content on the site.
          </p>

          <h2 className="terms-subtitle">Links to Other Websites</h2>
          <p>
            This is a tool website, and we might also write articles in the future related to our tools, and those links belong to other websites that we don't own or control. We can't control what happens on those websites or services. We aren't responsible for their content, privacy rules, or actions. You agree that we aren't responsible if you have problems because of those other websites or services.
          </p>

          <h2 className="terms-subtitle">Google Adsense</h2>
          <p>
            On our website, some ads might display by Google AdSense. Google uses the DART cookies to show ads based on your visits to our website and other sites. DART cookies collect non-personal information and do not track details like name, email, or address. You can opt out of the DART cookies by visiting Google's ads and content network privacy policy at{" "}
            <a href="https://policies.google.com/technologies/ads" className="terms-link" target="_blank" rel="noopener noreferrer">
              https://policies.google.com/technologies/ads
            </a>
          </p>

          <h2 className="terms-subtitle">Changes</h2>
          <p>
            We can change these rules anytime we want. If we make a big change, you can always find them on this page. We decide what counts as a big change.
          </p>

          <h2 className="terms-subtitle">Contact Us</h2>
          <p>
            If you have questions about these rules, please email us at{" "}
            <a href="mailto:healthwiibes@gmail.com" className="terms-link">
              healthwiibes@gmail.com
            </a>
            .
          </p>

          <div className="terms-conclusion">
            <p>
              By using HealthWibes, you agree to follow these rules. If you don't agree, please don't use our website.
            </p>
          </div>
        </div>

        <div className="terms-footer">
          <Link to="/" className="terms-home-link">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Terms;